import * as actionTypes from "../actionTypes";
import { updateObject } from "../../shared/utility";
import { stat } from "fs";

const initialState = {
  isSubscribed: null,
  isSubscriber: null,
  paymentType: null,
  paymentInfo: null,
  subscriptionSMSData: null,
  error: null,
  loading: false,
};

//handle subscription
export const subscriptionStart = (state: any) => {
  return updateObject(state, { error: null, loading: true });
};

export const subscriptionSuccess = (state: any) => {
  return updateObject(state, {
    error: null,
    loading: false,
  });
};

export const subscriptionFailed = (state: any, action: any) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

//handle Subscription verification
export const verifySubscriptionSuccess = (state: any, action: any) => {
  return updateObject(state, {
    isSubscribed: action.data?.subscribed,
    isSubscriber: action.data?.subscriber,
    paymentType: action.data?.paymentType,
    error: null,
    loading: false,
  });
};

const verifyTelebirrUnSubscriptionSuccess = (state: any) => {
  return updateObject(state, {
    error: null,
    loading: false,
  });
}

//handle Subscription Plan Details
const getSubscriptionPlanDetailsStart = (state: any) => {
  return updateObject(state, { error: null, loading: true });
};

const getSubscriptionPlanDetailsSuccess = (state: any, action: any) => {
  return updateObject(state, {
    loading: false,
    error: null,
    paymentInfo: action.paymentInfo,
  });
};

const getSubscriptionPlanDetailsFailed = (state: any, action: any) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

// get SMS data for airtime subscription payment
const getSubscriptionSMSdataStart = (state: any) => {
  return updateObject(state, { error: null, loading: true });
};

const getSubscriptionSMSdataSuccess = (state: any, action: any) => {
  return updateObject(state, {
    loading: false,
    error: null,
    subscriptionSMSData: action.subscriptionSMSData,
  });
};
const getSubscriptionSMSdataFailed = (state: any, action: any) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

// ---------- Subscribe categories ---------- //
const subscribeCategoriesStart = (state: any) => {
  return updateObject(state, { error: null, loading: true });
};

const subscribeCategoriesSuccess = (state: any, action: any) => {
  return updateObject(state, {
    loading: false,
    error: null,
  });
};

const subscribeCategoriesFailed = (state: any, action: any) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

const subscriptionReducer = (state = initialState, action: any) => {
  switch (action.type) {
    //handle subscription
    case actionTypes.SUBSCRIPTION_START:
      return subscriptionStart(state);
    case actionTypes.SUBSCRIPTION_SUCCESS:
      return subscriptionSuccess(state);
    case actionTypes.SUBSCRIPTION_FAIL:
      return subscriptionFailed(state, action);

    //handle Subscription verification
    case actionTypes.VERIFY_SUBSCRIPTION_SUCCESS:
      return verifySubscriptionSuccess(state, action);
    case actionTypes.VERIFY_TELEBIRR_UN_SUBSCRIPTION_SUCCESS:
      return verifyTelebirrUnSubscriptionSuccess(state);

    //handle Subscription verification
    case actionTypes.SUBSCRIPTION_PLAN_DETAILS_START:
      return getSubscriptionPlanDetailsStart(state);
    case actionTypes.SUBSCRIPTION_PLAN_DETAILS_SUCCESS:
      return getSubscriptionPlanDetailsSuccess(state, action);
    case actionTypes.SUBSCRIPTION_PLAN_DETAILS_FAIL:
      return getSubscriptionPlanDetailsFailed(state, action);

    //SMS data for airtime subscription
    case actionTypes.SUBSCRIPTION_SMS_DETAILS_START:
      return getSubscriptionSMSdataStart(state);
    case actionTypes.SUBSCRIPTION_SMS_DETAILS_SUCCESS:
      return getSubscriptionSMSdataSuccess(state, action);
    case actionTypes.SUBSCRIPTION_SMS_DETAILS_FAIL:
      return getSubscriptionSMSdataFailed(state, action);

    // Subscribe Categories
    case actionTypes.SUBSCRIBE_CATEGORIES_START:
      return subscribeCategoriesStart(state);
    case actionTypes.SUBSCRIBE_CATEGORIES_SUCCESS:
      return subscribeCategoriesSuccess(state, action);
    case actionTypes.SUBSCRIBE_CATEGORIES_FAIL:
      return subscribeCategoriesFailed(state, action);

    default:
      return state;
  }
};

export default subscriptionReducer;
